import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { ActivityQueryParams } from '../types/analytics.types';

export const activityKeys = {
  all: ['analytics', 'activity'] as const,
  logins: (params?: ActivityQueryParams) =>
    [...activityKeys.all, 'logins', params] as const,
};

export const useActivityData = (params?: ActivityQueryParams, enabled = true) => {
  return useQuery({
    queryKey: activityKeys.logins(params),
    queryFn: async () => {
      const response = await analyticsApi.getActivityLogins(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
